const c = {
  name: "Oilsplash",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0c-2.9,0-5.7,0.6-8.3,1.8C4.6,5,0,12.2,0,20c0,0.2,0,0.4,0,0.5c0.1,3.6,1.2,7.1,3.1,10.1
			C2.4,31.4,2,32.4,2,33.5C2,36,4,38,6.5,38c1.1,0,2.1-0.4,2.9-1.1c3.2,2,6.8,3.1,10.6,3.1c3.4,0,6.8-0.9,9.8-2.6
			c4.9-2.8,8.4-7.4,9.6-12.8l0.2-0.8c0.2-1.2,0.4-2.5,0.4-3.8C40,9,31,0,20,0z M38,20c0,0.7-0.1,1.5-0.2,2.2
			c-7.8-3.4-16.8-2.3-23.6,2.6c3-6.8,2.8-14.8-0.7-21.5C15.6,2.4,17.8,2,20,2C29.9,2,38,10.1,38,20z M4.7,29.4
			c-1.5-2.5-2.4-5.3-2.6-8.3c2.1-0.8,4.5-0.3,6.1,1.3c2,2,2.2,5,0.6,7.2C8.1,29.2,7.3,29,6.5,29C5.8,29,5.2,29.1,4.7,29.4z M11.7,4
			c3.6,6.7,3.5,14.8,0,21.4c-0.2-1.6-0.9-3.2-2.2-4.5c-2-2-4.9-2.7-7.5-2C2.4,12.7,6.1,7,11.7,4L11.7,4z M6.5,36
			C5.1,36,4,34.9,4,33.5S5.1,31,6.5,31S9,32.1,9,33.5S7.9,36,6.5,36z M10.6,35.3c0.2-0.6,0.4-1.2,0.4-1.8c0-0.9-0.2-1.6-0.7-2.3
			c4.4-3.6,11-3.4,15.1,0.7c1.2,1.2,2.1,2.6,2.6,4.2C25.6,37.3,22.8,38,20,38C16.6,38,13.4,37.1,10.6,35.3z M29.9,35
			c-0.7-1.7-1.7-3.3-3-4.6c-3.3-3.3-7.8-4.5-12.1-3.6c6.4-5,15.1-6.1,22.7-2.7C36.4,28.7,33.7,32.5,29.9,35z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Oilsplash
};
